import { Cancel as CancelIcon, QrCode as QrCodeIcon } from '@mui/icons-material'
import { FC } from 'react'
import { PickerButton } from '../BrandKit/BrandKitForm/subcomponents/PickerButton'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { TemplatesFlowcodeBtnProps } from './TemplatesFlowcodeBtn.types'
import { useRouter } from 'next/router'
import { useTemplatesFlowcodeBtn } from './TemplatesFlowcodeBtn.hooks'

export const TemplatesFlowcodeBtn: FC<TemplatesFlowcodeBtnProps> = ({
  hasSelectedFlowcode,
  onClickSelectFlowcode,
  onClickCreateFlowcode,
  onFlowcodeRemoved,
  displayValue,
  variant
}) => {
  const { label, handleClick, isLoading, userHasFlowcodes, showAsLink } = useTemplatesFlowcodeBtn({
    onClickSelectFlowcode,
    onClickCreateFlowcode
  })
  const router = useRouter()

  return (
    <PickerButton
      hasValue={userHasFlowcodes && hasSelectedFlowcode}
      onClick={handleClick}
      buttonStartIcon={QrCodeIcon}
      startIcon={
        <QrCodeIcon
          sx={{
            fontSize: theme => theme.spacing(5),
            color: 'secondary.contrastText'
          }}
        />
      }
      removeClickHandler={onFlowcodeRemoved}
      endIcon={
        <CancelIcon
          sx={theme => ({
            color: 'action.active',
            width: theme.spacing(5),
            height: theme.spacing(5)
          })}
        />
      }
      endIconCustomAriaLabel="clear selected flowcode"
      displayValue={displayValue}
      label={label}
      disabled={isLoading}
      variant={variant}
      href={
        showAsLink
          ? {
              pathname: Routes.CREATE_FLOWCODE,
              query: {
                redirectTo: encodeURIComponent(router.asPath)
              }
            }
          : undefined
      }
      data-testid="templates-flowcode-picker-button"
    />
  )
}
